module.exports = __webpack_public_path__ + "img/plus.4dc944ba.svg";